import React from 'react'
import './Footer.css'

const Footer = () => {
    return (
        <footer className='footer'>
            <div className="footer__container">
                <div className="footer__content">
                    <p>Copyright ©2023 JINGHUI MA. All rights reserved.</p>
                    <span>" Desgined & Coded By <a href='https://shehabwaleedd.vercel.app/' target='__blank'>Shehab Waleed</a>"</span>
                </div>
            </div>
        </footer>
    )
}

export default Footer